import {
    PASSWORD_MIN_LENGTH,
    REGEX_HAS_UPPERCASE,
    REGEX_HAS_LOWERCASE,
    REGEX_HAS_DIGIT,
    REGEX_HAS_SPECIAL_CHAR,
} from '../constants';

export interface ValidateOutput {
    isValid: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rules: any;
}

export interface ValidatePasswordOutput extends ValidateOutput {
    rules: {
        hasUppercaseLetter: boolean;
        hasLowercaseLetter: boolean;
        hasNumber: boolean;
        hasSpecialChar: boolean;
        hasMinimumChars: boolean;
    };
}

export const validatePassword: (password: string) => ValidatePasswordOutput = (password) => {
    const hasUppercaseLetter = REGEX_HAS_UPPERCASE.test(password);
    const hasLowercaseLetter = REGEX_HAS_LOWERCASE.test(password);
    const hasNumber = REGEX_HAS_DIGIT.test(password);
    const hasSpecialChar = REGEX_HAS_SPECIAL_CHAR.test(password);
    const hasMinimumChars = password.length >= PASSWORD_MIN_LENGTH;

    return {
        isValid: hasUppercaseLetter && hasLowercaseLetter && hasNumber && hasSpecialChar && hasMinimumChars,
        rules: {
            hasUppercaseLetter,
            hasLowercaseLetter,
            hasNumber,
            hasSpecialChar,
            hasMinimumChars,
        },
    };
};


export function formatCarPlate(value: string): string {
    let raw = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    raw = raw.slice(0, 6);

    if (raw.length <= 2) return raw;
    if (raw.length <= 4) return raw.slice(0, 2) + '-' + raw.slice(2);
    return raw.slice(0, 2) + '-' + raw.slice(2, 4) + '-' + raw.slice(4);
}

export function isValidPlate(plate: string): boolean {
  return /^[A-Z0-9]{2}-[A-Z0-9]{2}-[A-Z0-9]{2}$/i.test(plate);
}

export function formatSeatCount(value: string): string {
    const num = Number(value);

    if (isNaN(num)) return '';
    return Math.max(0, Math.min(50, num)).toString();
}

